import React, { BaseSyntheticEvent, useContext } from 'react'
import { Box, Flex, Input, Text } from '@chakra-ui/react'
import { TreeViewContext } from './TreeViewContext'
import { TreeViewDroppable } from './TreeViewDroppable'
import { renderIcon } from './TreeView.utils'
import {
  IReportBlueprintChart,
  IReportComponentBlueprint,
} from '../../../../services/decoders/blueprintDecoder'

interface AvailableChartsProps {
  onSearchChange?: (value: string) => void
  chartList: IReportBlueprintChart[]
}

export const AvailableCharts = ({
  onSearchChange,
  chartList,
}: AvailableChartsProps) => {
  const { currentType } = useContext(TreeViewContext)

  const handleSearchChange = (e: BaseSyntheticEvent) => {
    onSearchChange && onSearchChange(e.target.value)
  }

  return (
    <Flex flexDir="column">
      <Text
        textStyle="h3"
        ml="20px"
        mb="12px">
        Available charts
      </Text>
      <Input
        marginLeft="20px"
        minHeight="40px"
        marginBottom="10px"
        placeholder="Filter"
        type="text"
        borderRadius="0"
        borderColor="rgba(0, 0, 0, .1)"
        onChange={handleSearchChange}
      />
      <Box
        border="1px solid rgba(0, 0, 0, .1)"
        marginLeft="20px"
        maxH="352px"
        overflowY="auto">
        <TreeViewDroppable
          droppableId={'available'}
          data={chartList as unknown as IReportComponentBlueprint}
          type={currentType || 'available'}
          disableClick
          renderClone={getDraggableChildrenFn(chartList)}
          isDropDisabled={true}
          disableAccordion
        />
      </Box>
    </Flex>
  )
}

const getDraggableChildrenFn =
  (availableItems: IReportBlueprintChart[]) => (provided, snapshot, rubric) => {
    const item = availableItems[rubric.source.index]

    return (
      <Box
        {...provided.draggableProps}
        ref={provided.innerRef}
        style={provided.draggableProps.style}>
        <Box
          maxW="400px"
          pl="16px"
          position="relative"
          backgroundColor={snapshot.isDragging ? 'gray.50' : 'white'}>
          <Flex
            cursor="pointer"
            p="4px 24px"
            alignItems="center">
            {renderIcon(item.type)}
            <Text
              fontSize="14px"
              ml="8px"
              maxW="90%"
              textOverflow="ellipsis">
              {item.name}
            </Text>
          </Flex>
        </Box>
      </Box>
    )
  }

AvailableCharts.propTypes = {}

export default AvailableCharts
